import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/outbox/')({
  beforeLoad: () => {
    throw redirect({ to: '/app/conversations', replace: true });
  },
});
